<template>
  <div id="form-rules">
    <el-drawer
      class="sideDrawer"
      :size="drawerSize"
      title="表单权限规则设置"
      :visible.sync="dialogVisible"
      appendToBody
      :close-on-click-modal="false"
      destory-on-close
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '90%'" />
      <i @click="drawerSize = '90%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <el-row style="padding: 20px">
        <el-col :span="2" class="header-style title">所属表</el-col>
        <el-col :span="5" class="header-style title">字段</el-col>
        <el-col :span="2" class="header-style title">重点字段</el-col>
        <el-col :span="8" class="header-style title">流程审批编辑规则</el-col>
        <el-col :span="7" class="header-style title">字段必填及可见范围设置</el-col>
      </el-row>
      <div style="padding: 20px" v-for="(item, index) in rules.json.table" :key="index">
        <el-row
          class="header-style title"
          :style="{
            justifyContent: 'left',
            backgroundColor: '#f4f5f7'
          }"
          >{{ item.main ? '主表' : '子表' }}————{{ item.description }}</el-row
        >
        <el-row
          v-for="(items, indexs) in item.fields"
          :key="indexs"
          :style="{
            height: items.originDownload ? '90px' : '60px'
          }"
        >
          <el-col
            :span="2"
            class="cell-style"
            :style="{
              height: items.originDownload ? '90px' : '60px'
            }"
            >{{ item.main ? '主表' : item.description }}</el-col
          >
          <el-col
            :span="5"
            class="header-style"
            :style="{
              height: items.originDownload ? '90px' : '60px'
            }"
            >{{ items.description }}</el-col
          >
          <el-col
            :span="2"
            class="header-style"
            :style="{
              height: items.originDownload ? '90px' : '60px'
            }"
          >
            <el-checkbox
              :disabled="items.systemImportant == '1'"
              v-if="items.write"
              v-model="items.important"
              true-label="true"
              false-label="false"
            ></el-checkbox>
          </el-col>
          <el-col
            :span="8"
            class="cell-style"
            :style="{
              height: items.originDownload ? '90px' : '60px'
            }"
          >
            <el-row v-if="items.write"
              >可编辑范围：
              <div style="display: flex">
                <el-radio-group v-model="items.write.type" :disabled="items.systemEditRead == '1'" @change="setEdit(items)">
                  <el-radio label="0">无</el-radio>
                  <el-radio label="1">所有人</el-radio>
                  <el-radio label="2">部分可编辑</el-radio>
                </el-radio-group>
                <el-link
                  :underline="false"
                  v-if="items.write.type == 2"
                  type="primary"
                  style="padding-left: 10px; margin-top: -3px"
                  @click="setPersonRules(index, indexs, 'write')"
                  >可编辑范围</el-link
                >
              </div>
            </el-row>
          </el-col>
          <el-col
            :span="7"
            class="cell-style"
            :style="{
              height: items.originDownload ? '90px' : '60px'
            }"
          >
            <el-row v-if="items.write"
              >是否必填：
              <el-checkbox
                v-model="items.required"
                true-label="true"
                false-label="false"
                @change="setRequired(items)"
                :disabled="items.systemRequired == '1'"
              ></el-checkbox
            ></el-row>
            <el-row
              >可见范围：
              <el-radio-group v-model="items.read.type" :disabled="items.required == 'true' || items.systemRequired == '1'">
                <el-radio label="0">隐藏</el-radio>
                <el-radio label="1">所有人</el-radio>
                <el-radio label="2">部分可见</el-radio>
              </el-radio-group>
              <el-button v-if="items.read.type == 2" type="text" style="padding-left: 10px" @click="setPersonRules(index, indexs, 'read')">可见范围</el-button>
            </el-row>
            <el-row v-if="items.originDownload"
              >原文件下载：
              <el-radio-group v-model="items.originDownload.type" :disabled="items.required == 'true' || items.systemRequired == '1'">
                <el-radio label="0">隐藏</el-radio>
                <el-radio label="1">所有人</el-radio>
                <el-radio label="2">部分可见</el-radio>
              </el-radio-group>
              <el-button v-if="items.originDownload.type == 2" type="text" style="padding-left: 10px" @click="setPersonRules(index, indexs, 'originDownload')"
                >可见范围</el-button
              >
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisible = false" size="medium">取 消</el-button
        ><el-button type="primary" @click="handleClose" size="medium" :loading="loading">确 定</el-button>
      </div>
    </el-drawer>
    <PersonalRules ref="PersonalRules" @onConfirm="onConfirm"></PersonalRules>
  </div>
</template>

<script>
import PersonalRules from './personalRules.vue'
import req from '@/request.js'

export default {
  props: {},
  components: { PersonalRules },
  data() {
    return {
      dialogVisible: false,
      drawerSize: '90%',
      rules: {
        json: {
          table: {}
        }
      },
      mainTable: [],
      subTable: {},
      recordTable: {},
      param: {},
      loading: false
    }
  },
  created() {},
  methods: {
    /**
     * 请求接口 展示表单字段权限弹框
     * @param {*} param 接口参数
     */
    showDialog(param) {
      this.param = param
      req.post(req.getContext().form + '/form/rights/v1/getPermissionCustomNew', param).then((res) => {
        this.rules = res.data
        this.dialogVisible = true
      })
    },
    /**
     * 调用子组件方法 展示授权范围对话框
     * @param {*} val
     */
    setPersonRules(index, indexs, key) {
      this.$refs.PersonalRules.showDialog(this.rules, index, indexs, key)
    },
    onConfirm(val, index, indexs, key) {
      this.rules.json.table[index].fields[indexs][key].person = val
    },
    handleClose() {
      this.loading = true
      this.param.permission = ''
      this.param.permission = JSON.stringify(this.rules.json)
      req.post(req.getContext().form + '/form/newRight/v1/save', this.param).then((res) => {
        this.loading = false
        if (res.data.state) {
          this.$message.info('表单权限配置保存成功！')
          this.dialogVisible = false
        }
      })
    },
    setRequired(val) {
      if (val.required == 'true') {
        val.read.type = '1'
        if (val.person) {
          val.person = []
        }
      }
    }
  }
}
</script>

<style scoped>
.header-style {
  padding: 10px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f4f5f7;
}
.cell-style {
  padding: 10px;
  height: 60px;
  display: flex;
  border: 1px solid #f4f5f7;
  justify-content: flex-start;
  flex-direction: column;
}
.title {
  font-size: 15px;
  font-weight: bold;
}
</style>
